import { motion } from "framer-motion";
import { JOURNEY } from "@/lib/site";

export const PatientJourney = () => {
  return (
    <section
      data-testid="patient-journey"
      aria-labelledby="journey-heading"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
            Patient Journey
          </div>
          <h2
            id="journey-heading"
            className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
          >
            What to expect during your consultation.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            A structured, transparent process — so you always know what happens
            next in your care.
          </p>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {JOURNEY.map((j, i) => (
              <motion.div
                key={j.step}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`journey-step-${i}`}
                className="relative"
              >
                <div className="relative z-10 h-24 w-24 mx-auto lg:mx-0 rounded-full bg-white border border-blue-100 shadow-[0_10px_30px_-15px_rgba(30,58,138,0.3)] flex items-center justify-center">
                  <span className="font-serif text-2xl text-blue-800">
                    {j.step}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-xl text-slate-900 text-center lg:text-left">
                  {j.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed text-center lg:text-left">
                  {j.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientJourney;
